namespace Queries {
    interface IOrderQueryFilter
        extends IQueryFilter {
        
        closed?: boolean;
    }

    interface IOrderResult {

    }

    export class OrderQuery
        implements ITQueryInfo<Indexes.Order, Entities.Order, IOrderQueryFilter, IOrderResult> {

        private _repository: RavenDbClient;
    
        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }

        async execute(context: ITQueryFilterRequestContext<Indexes.Order, Entities.Order, IOrderQueryFilter>) {
            const { results: results, stats: stats } = await this._repository.queryDocuments<Entities.Order>("orders", "", {}, context.from, context.limit)

            return {
                docs: results,
                totalResults: stats.totalResults
            }
        }

        // async execute(context: ITQueryFilterRequestContext<Indexes.Order, Entities.Order, IOrderQueryFilter>) {

        //     let query = this._query;
        //     if (context.filter.closed != null)
        //         query = query.whereEquals("byClosed", context.filter.closed);

        //     var result  = await query
        //         .orderBy(context.orderBy ?? "byDateTimeStart", true)
        //         .skip(context.from)
        //         .limit(context.limit)
        //         .toArray();
            
        //     var users = await this._repository.getArray<Entities.User>(result.docs.map(a => a.userId).distinct(), Entities.User);

        //     var docs = result.docs.map(doc => ({
        //         ...doc,
        //         username: users[doc.userId]?.username
        //     }));

        //     return {
        //         docs: docs,
        //         totalResults: result.totalResults
        //     }
        // }
        
    }
}